import React, { useState } from 'react';
import styled from 'styled-components';
import DemoRequestForm from '../../../components/DemoRequestForm.tsx';

const SectionContainer = styled.section`
  padding: 5rem 2rem;
  background: linear-gradient(135deg, #4299e1 0%, #667eea 100%);
  color: white;
`;

const Content = styled.div`
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
`;

const Title = styled.h2`
  font-size: clamp(2rem, 4vw, 3rem);
  margin-bottom: 1.5rem;
  font-weight: bold;
`;

const Description = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  line-height: 1.6;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const CTAContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const PrimaryButton = styled.button`
  padding: 1rem 2rem;
  font-size: 1.1rem;
  background: white;
  color: #4299e1;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
`;

const SecondaryButton = styled.button`
  padding: 1rem 2rem;
  font-size: 1.1rem;
  background: transparent;
  color: white;
  border: 2px solid white;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: transform 0.2s, background-color 0.2s;

  &:hover {
    transform: translateY(-2px);
    background: rgba(255, 255, 255, 0.1);
  }
`;

const Highlight = styled.span`
  color: #ebf8ff;
  font-weight: bold;
`;

export const ClosingSection: React.FC = () => {
  const [isDemoFormOpen, setIsDemoFormOpen] = useState(false);

  const openDemoForm = () => setIsDemoFormOpen(true);
  const closeDemoForm = () => setIsDemoFormOpen(false);

  return (
    <SectionContainer>
      <Content>
        <Title>Ready to Transform Your Virtual Events?</Title>
        <Description>
          Join the <Highlight>organizations</Highlight> using SpinToConnect to create meaningful connections and engaging networking experiences.
        </Description>
        <CTAContainer>
          <PrimaryButton onClick={() => document.getElementById('pricing-section')?.scrollIntoView({ behavior: 'smooth' })}>
            Get Started Today
          </PrimaryButton>
          <SecondaryButton onClick={openDemoForm}>
            Request Demo
          </SecondaryButton>
        </CTAContainer>
      </Content>
      {isDemoFormOpen && <DemoRequestForm onClose={closeDemoForm} />}
    </SectionContainer>
  );
}; 